import React, { useRef } from "react";

export default function MoreOrLess({ Paragraph, ...props }) {
  const ref = useRef();
  return (
    <div ref={ref} {...props}>
      {Paragraph}
    </div>
    // <ReadMoreAndLess
    //   ref={ref}
    //   {...props}
    //   charLimit={250}
    //   readMoreText=" see more"
    //   readLessText=" see less"
    // >
    //   {Paragraph}
    // </ReadMoreAndLess>
  );
}
